import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileArrowLeftOut: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-arrow-left-out, document-arrow-left-out, outgoing"><path d="M14.75 21.25H19.25V9.25L12.75 2.75H4.75V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.25439V9.24982H18.7501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M5 19H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 16L3.75 19L6.75 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileArrowLeftOut;
